import { fetchAdminApi } from "./api";
import type {
	PVBulkAuditResult,
	PVEmployeeAuditResult,
	PVSeedResult,
	PVCleanupResult,
	PVScenario,
} from "@/types";

// ── Seeder ───────────────────────────────────────────────────

export async function getScenarios(): Promise<PVScenario[]> {
	return fetchAdminApi("/pipeline-seeder/scenarios");
}

export async function seedData(params: {
	organizationId?: string;
	period: { year: number; month: number };
	scenarios?: string[];
	timezone?: string;
}): Promise<PVSeedResult> {
	return fetchAdminApi("/pipeline-seeder/seed", {
		method: "POST",
		body: JSON.stringify(params),
	});
}

export async function cleanupData(organizationId: string): Promise<PVCleanupResult> {
	return fetchAdminApi("/pipeline-seeder/cleanup", {
		method: "DELETE",
		body: JSON.stringify({ organizationId }),
	});
}

// ── Validator ────────────────────────────────────────────────

export async function runBulkAudit(params: {
	organizationId: string;
	periodStart: string;
	periodEnd: string;
	stages?: string[];
}): Promise<PVBulkAuditResult> {
	return fetchAdminApi("/pipeline-validator/audit", {
		method: "POST",
		body: JSON.stringify(params),
	});
}

export async function runEmployeeAudit(
	userId: string,
	params: {
		organizationId: string;
		periodStart: string;
		periodEnd: string;
		stages?: string[];
	},
): Promise<PVEmployeeAuditResult> {
	return fetchAdminApi(`/pipeline-validator/audit/${userId}`, {
		method: "POST",
		body: JSON.stringify(params),
	});
}

export async function getResolvedConfig(
	userId: string,
	organizationId: string,
): Promise<Record<string, unknown>> {
	return fetchAdminApi(
		`/pipeline-validator/config/${userId}?organizationId=${organizationId}`,
	);
}
